var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.flowData
    ? _c("savvy", {
        ref: "savvyFlowContainer",
        attrs: { id: _vm.flowId },
        domProps: { innerHTML: _vm._s(_vm.flowData.html) }
      })
    : _c("div", { ref: "savvyFlowContainer" })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }